import "../assets/Inliner.css";
import { defineComponent as z, useCssVars as W, unref as e, ref as b, computed as g, watchEffect as F, openBlock as $, createBlock as C, Transition as D, withCtx as S, withDirectives as y, createElementVNode as c, createVNode as m, vShow as k, createElementBlock as G, withModifiers as Y, createCommentVNode as E, normalizeClass as U, normalizeStyle as Z, TransitionGroup as ee, onUpdated as te, resolveDynamicComponent as oe, mergeProps as ae } from "vue";
import { D as q, g as se, b as B, a as L } from "./maps.CbFe18_X.js";
import { i as ne } from "./XClose.vue_vue_type_style_index_0_lang.DdsWTOOn.js";
import { d as ie } from "./debounce.BDLEW31m.js";
import { u as O } from "./index.72N0HVaZ.js";
import { e as J, f as Q, o as A, n as le, u as de } from "./useStore.CuiH5QIB.js";
import { a as H, m as K, t as re, r as ce } from "./useModal.CgbJKM9V.js";
import { _ as T } from "./Back.vue_vue_type_style_index_0_lang.BwoLjIqK.js";
import { _ as N } from "./Steps.vue_vue_type_style_index_0_lang.D6OYNA9I.js";
import { _ as R } from "./Modal.vue_vue_type_style_index_0_lang.DFXQJH4s.js";
import { _ as me, u as ue, a as pe, i as fe } from "./useImageStyles.DopfKJ2_.js";
import { _ as he } from "./_plugin-vue_export-helper.CHgC5LLL.js";
import { p as ge } from "./widgets-core.es.DdX21Kyh.js";
import { u as _e, h as ve } from "./Text.vue_vue_type_style_index_0_lang.CGXfDawb.js";
import { p as j } from "./parseToolData.DTNrjPdf.js";
function X(i) {
  return i === "px" ? J : Q;
}
function I(i) {
  const {
    format: u,
    top: l,
    right: t,
    bottom: a,
    left: n
  } = i.margin, o = X(u);
  return `${o(l)} ${o(t)} ${o(a)} ${o(n)}`;
}
function V(i) {
  const { width: u, widthFormat: l } = i;
  return `${X(l)(u)}`;
}
function M(i) {
  return {
    left: "start",
    center: "center",
    right: "end"
  }[i.alignment];
}
const be = { class: "thn--tool-inline-container" }, xe = { class: "thn--tool-inline-circular__content" }, ye = { class: "thn--tool-inline-circular__inliner" }, ke = /* @__PURE__ */ z({
  __name: "Circular",
  props: {
    language: {},
    device: {},
    steps: {},
    hasSteps: {},
    layout: {},
    embedded: {}
  },
  setup(i, { expose: u }) {
    W((h) => ({
      df302eec: e(M)(h.embedded[h.device]),
      "7961a078": e(Q)(r.value),
      e88ef6c2: e(J)(v.value),
      "50e57692": e(I)(h.embedded.desktop)
    }));
    const l = ie(re, 200, { leading: !0, trailing: !1 }), t = {
      [q.Desktop]: 530,
      [q.Mobile]: 340
    }, a = {
      horizontal: 0.1,
      vertical: 0.2
    }, n = i, o = A(), p = b(!1), d = b(), { width: x } = O(d), r = g(() => n.embedded[n.device].width), v = g(() => t[n.device] * (r.value / 100)), _ = g(() => x.value * (1 - 2 * a.vertical));
    F(() => {
      const h = x.value * a.horizontal;
      o == null || o.styles.addCssVariables(
        o.literals.device === q.Desktop ? {
          "--step-padding": `0px ${h}px 0px ${h}px`,
          "--module-margin-top": "20px",
          "--xclose-margin": "0px"
        } : {
          "--step-padding": `0px ${h}px 0px ${h}px`,
          "--module-margin-top": "15px",
          "--xclose-margin": "5px"
        }
      );
    });
    function s() {
      p.value = !1;
    }
    function P() {
      p.value = !0;
    }
    return u({
      show: s,
      hide: P
    }), (h, w) => ($(), C(D, {
      name: "fade",
      appear: ""
    }, {
      default: S(() => [
        y(c("div", be, [
          c("div", {
            class: "thn--tool-inline-circular",
            ref_key: "rootDom",
            ref: d
          }, [
            c("div", xe, [
              c("div", ye, [
                m(T, { class: "thn--tool-inline-circular__back" }),
                m(N, {
                  class: "thn--tool-inline-circular__steps",
                  steps: n.steps,
                  "has-extra-steps": n.hasSteps,
                  "max-height": _.value
                }, null, 8, ["steps", "has-extra-steps", "max-height"]),
                m(D, { name: "fade" }, {
                  default: S(() => [
                    y(m(R, { "terms-text": e(H) }, null, 8, ["terms-text"]), [
                      [k, e(K)]
                    ])
                  ]),
                  _: 1
                })
              ])
            ]),
            m(D, { name: "fade" }, {
              default: S(() => [
                e(K) ? ($(), G("div", {
                  key: 0,
                  class: "thn--tool-xclose thn--tool-xclose--modal",
                  onMousedown: w[0] || (w[0] = Y(
                    //@ts-ignore
                    (...f) => e(l) && e(l)(...f),
                    ["left"]
                  )),
                  onClick: w[1] || (w[1] = //@ts-ignore
                  (...f) => e(l) && e(l)(...f))
                }, [
                  m(e(ne), { class: "thn--tool-xclose__svg" })
                ], 32)) : E("", !0)
              ]),
              _: 1
            })
          ], 512)
        ], 512), [
          [k, !p.value]
        ])
      ]),
      _: 1
    }));
  }
}), $e = {
  class: "thn--tool-custom-content",
  "data-add-module": !0
}, Se = /* @__PURE__ */ z({
  __name: "CustomImage",
  props: {
    language: {},
    device: {},
    steps: {},
    layout: {},
    embedded: {}
  },
  setup(i, { expose: u }) {
    W((s) => ({
      25374623: e(V)(s.embedded.desktop),
      "44b94ec6": e(I)(s.embedded.desktop),
      "82c8f1fc": e(M)(s.embedded.desktop),
      "6dd8a49c": e(M)(s.embedded.mobile),
      "6739f31e": e(V)(s.embedded.mobile),
      "9d648692": e(I)(s.embedded.mobile)
    }));
    const l = i, t = A(), a = b(), n = b(!1), { width: o, height: p } = O(a), d = g(() => l.steps[se.Main][0]), x = g(() => {
      if (o.value) {
        const s = (t == null ? void 0 : t.literals.device) === q.Mobile ? 0.9 : 0.8;
        return o.value * s;
      }
      return 300;
    }), r = g(() => {
      if (p.value) {
        const s = (t == null ? void 0 : t.literals.device) === q.Mobile ? 0.9 : 0.8;
        return p.value * s;
      }
      return 300;
    });
    function v() {
      n.value = !1;
    }
    function _() {
      n.value = !0;
    }
    return u({
      show: v,
      hide: _
    }), (s, P) => ($(), C(D, {
      name: "fade",
      appear: ""
    }, {
      default: S(() => [
        y(c("div", {
          class: "thn--tool-inline-custom-image",
          ref_key: "rootDom",
          ref: a
        }, [
          c("div", $e, [
            m(me, {
              class: "thn--tool-inline-custom-image__image",
              "module-props": d.value,
              "max-width": x.value,
              "max-height": r.value
            }, null, 8, ["module-props", "max-width", "max-height"])
          ])
        ], 512), [
          [k, !n.value]
        ])
      ]),
      _: 1
    }));
  }
}), we = /* @__PURE__ */ he(Se, [["__scopeId", "data-v-3b92e182"]]), De = { class: "thn--tool-inline-square__inliner" }, qe = /* @__PURE__ */ z({
  __name: "Square",
  props: {
    language: {},
    device: {},
    steps: {},
    hasSteps: {},
    layout: {},
    embedded: {}
  },
  setup(i, { expose: u }) {
    W((d) => ({
      "327edbe1": e(V)(d.embedded.desktop),
      "794e7a9f": e(I)(d.embedded.desktop),
      "0e860dc0": e(M)(d.embedded.desktop),
      "267e5734": e(M)(d.embedded.mobile),
      "55da7e1a": e(V)(d.embedded.mobile),
      "82d55b16": e(I)(d.embedded.mobile)
    }));
    const l = i, t = A(), a = b(!1), n = b();
    F(() => {
      t == null || t.styles.addCssVariables(
        t.literals.device === q.Desktop ? {
          "--step-padding": "32px",
          "--module-margin-top": "16px",
          "--xclose-margin": "10px"
        } : {
          "--step-padding": "25px",
          "--module-margin-top": "15px",
          "--xclose-margin": "5px"
        }
      );
    });
    function o() {
      a.value = !1;
    }
    function p() {
      a.value = !0;
    }
    return u({
      show: o,
      hide: p
    }), (d, x) => ($(), C(D, {
      name: "fade",
      appear: ""
    }, {
      default: S(() => [
        y(c("div", {
          class: "thn--tool-inline-square",
          ref_key: "rootDom",
          ref: n
        }, [
          c("div", De, [
            m(T, { class: "thn--tool-inline-square__back" }),
            m(N, {
              class: "thn--tool-inline-square__steps",
              steps: l.steps,
              "has-extra-steps": l.hasSteps,
              "tool-kind": e(B).Inliner
            }, null, 8, ["steps", "has-extra-steps", "tool-kind"]),
            m(D, { name: "fade" }, {
              default: S(() => [
                y(m(R, { "terms-text": e(H) }, null, 8, ["terms-text"]), [
                  [k, e(K)]
                ])
              ]),
              _: 1
            })
          ])
        ], 512), [
          [k, !a.value]
        ])
      ]),
      _: 1
    }));
  }
}), Ce = { class: "thn--tool-inline-square-image__inliner" }, Ie = ["data-loaded"], Me = { class: "image__wrapper" }, Pe = ["src", "alt"], Ve = { class: "w-full h-full bg-base-300 flex items-center justify-center" }, Le = /* @__PURE__ */ z({
  __name: "SquareImage",
  props: {
    language: {},
    device: {},
    steps: {},
    hasSteps: {},
    layout: {},
    embedded: {}
  },
  setup(i, { expose: u }) {
    W((f) => ({
      "2e01d4ae": e(M)(f.embedded.desktop),
      "80fb7f6c": e(V)(f.embedded.desktop),
      e690b954: e(I)(f.embedded.desktop),
      "04402e2b": e(M)(f.embedded.mobile),
      e166a92c: e(V)(f.embedded.mobile),
      "4b98b6de": e(I)(f.embedded.mobile)
    }));
    const { t: l } = ge(), t = A(), a = i, n = b(), o = b(!1), p = b(!1), d = g(() => a.layout), x = g(() => a.device), { imageUrl: r, imageAlt: v } = ue(d, x), _ = g(() => {
      var f;
      return a.device === q.Mobile ? "top" : ((f = a.layout) == null ? void 0 : f.imagePosition) ?? "left";
    }), { imageStyles: s } = pe(
      g(() => a.layout),
      g(() => a.device),
      _
    );
    F(() => {
      t == null || t.styles.addCssVariables(
        t.literals.device === q.Desktop ? {
          "--step-padding": "28px",
          "--module-margin-top": "16px",
          "--xclose-margin": "10px",
          "--square-image-display": "grid"
        } : {
          "--step-padding": "20px",
          "--module-margin-top": "15px",
          "--xclose-margin": "5px",
          "--square-image-display": "flex"
        }
      ), r.value || (o.value = !1);
    });
    function P() {
      p.value = !1;
    }
    function h() {
      p.value = !0;
    }
    function w() {
      o.value = !0;
    }
    return u({
      show: P,
      hide: h
    }), (f, Be) => ($(), C(D, {
      name: "fade",
      appear: ""
    }, {
      default: S(() => [
        y(c("div", {
          class: "thn--tool-inline-square-image",
          ref_key: "rootDom",
          ref: n
        }, [
          c("div", Ce, [
            e(s) ? ($(), C(T, {
              key: 0,
              class: "thn--tool-inline-square-image__back"
            })) : E("", !0),
            c("div", {
              class: U([
                "thn--tool-inline-square-image__inliner__wrapper",
                _.value
              ])
            }, [
              c("div", {
                class: "thn--tool-inline-square-image__image",
                "data-loaded": o.value,
                style: Z(e(s))
              }, [
                m(ee, { name: "fade" }, {
                  default: S(() => [
                    y(c("div", Me, [
                      c("img", {
                        src: e(r),
                        onLoad: w,
                        alt: e(v)
                      }, null, 40, Pe)
                    ], 512), [
                      [k, o.value]
                    ]),
                    y(c("div", Ve, [
                      m(e(fe), {
                        class: "img-icon",
                        alt: e(l)("Picture icon")
                      }, null, 8, ["alt"])
                    ], 512), [
                      [k, !o.value]
                    ])
                  ]),
                  _: 1
                })
              ], 12, Ie),
              c("div", {
                class: U(["thn--tool-inline-square-image__content", [{ relative: o.value }]])
              }, [
                e(s) ? E("", !0) : ($(), C(T, {
                  key: 0,
                  class: "thn--tool-inline-square-image__back"
                })),
                m(N, {
                  class: "thn--tool-inline-square-image__steps",
                  steps: a.steps,
                  "has-extra-steps": a.hasSteps,
                  "layout-kind": e(L).SquareImage,
                  "tool-kind": e(B).Inliner
                }, null, 8, ["steps", "has-extra-steps", "layout-kind", "tool-kind"])
              ], 2),
              m(D, { name: "fade" }, {
                default: S(() => [
                  y(m(R, { "terms-text": e(H) }, null, 8, ["terms-text"]), [
                    [k, e(K)]
                  ])
                ]),
                _: 1
              })
            ], 2)
          ])
        ], 512), [
          [k, !p.value]
        ])
      ]),
      _: 1
    }));
  }
}), ze = ["data-builder-mode", "data-device", "data-content-alignment", "data-layout-kind", "data-text-direction"], Ye = /* @__PURE__ */ z({
  __name: "Inliner",
  props: {
    tool: {},
    context: {}
  },
  emits: [
    "hidden"
  ],
  setup(i, { emit: u }) {
    const l = {
      [L.Circular]: ke,
      [L.CustomImage]: we,
      [L.Square]: qe,
      [L.SquareImage]: Le
    }, t = i, a = u, n = le(j({
      ...t,
      toolKind: B.Inliner
    })), o = b(), p = g(() => {
      const {
        language: r,
        deviceViewport: v
      } = t.context, {
        content: {
          modules: _
        },
        settings: {
          layout: s,
          embedded: P
        }
      } = t.tool, h = _e(_), w = ve(_);
      return {
        language: r,
        device: v,
        steps: h,
        hasSteps: w,
        layout: s,
        embedded: P
      };
    }), d = g(() => {
      var v;
      if (!t.tool.settings.layout)
        return null;
      const r = (v = t.tool.settings.layout) == null ? void 0 : v.type;
      return l[r];
    });
    te(() => {
      de(j({
        ...t,
        toolKind: B.Layer
      }));
    });
    function x() {
      n.handlers.reset(), ce(), a("hidden");
    }
    return (r, v) => {
      var _, s;
      return $(), G("div", {
        class: "thn--tool thn--tool-inliner",
        "data-builder-mode": r.context.builderMode,
        "data-device": r.context.deviceViewport,
        "data-content-alignment": (_ = r.tool.settings.layout) == null ? void 0 : _.contentAlignment,
        "data-layout-kind": (s = r.tool.settings.layout) == null ? void 0 : s.type,
        "data-text-direction": e(n).rtl ? "rtl" : "ltr"
      }, [
        ($(), C(oe(d.value), ae({
          ref_key: "componentRef",
          ref: o
        }, p.value, { onAfterLeave: x }), null, 16))
      ], 8, ze);
    };
  }
});
export {
  Ye as _,
  V as a,
  M as b,
  I as c
};
//# sourceMappingURL=Inliner.vue_vue_type_style_index_0_lang.PF46ww3G.js.map
